import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
    openCardModal,
    closeCardModal,
    isAdjustPageOpen,
    toggleAdjustPage,
    isModalOpen,
    isProgressBarAnimationActive,
    activeProgressBarAnimation,
    changeSmartFunnelStep,
    getSmartFunnelStep,
    setAutomationLoading,
    isAutomationLoading,
    resetCardInterfaceState,
    validateModal,
    isModalValid,
    applyCard,
    updateWorkflowCard,
} from './card-interface.state';

export const withCardSelectedInterface = connect(
    state => ({
        isCardSelectedModalOpen: isModalOpen(state),
        isAdjustPageOpen: isAdjustPageOpen(state),
        isProgressBarAnimationActive: isProgressBarAnimationActive(state),
        smartFunnelStep: getSmartFunnelStep(state),
        isAutomationLoading: isAutomationLoading(state),
        isModalValid: isModalValid(state),
    }),
    dispatch => bindActionCreators({
        onUpdateWorkflowCard: updateWorkflowCard,
        onApplyCard: applyCard,
        onOpenCardModal: openCardModal,
        onCloseCardModal: closeCardModal,
        onSetAutomationLoading: setAutomationLoading,
        toggleAdjustPage,
        activeProgressBarAnimation,
        changeSmartFunnelStep,
        resetCardInterfaceState,
        validateModal,
    }, dispatch),
);
